import BaseType from "../BaseType";
import VolunteerLogItem from "./VolunteerLogItem";

export default class VolunteerLogHeader extends BaseType {
  LogItems: VolunteerLogItem[] = [];
}
